// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiHelp } from "@mdi/js";
import { Tooltip } from "antd";
import styled from "styled-components/macro";

import { useUser } from "hooks";

import { useSupportTicketStore } from "./useSupportTicketStore";

function SupportButton() {
  const { user } = useUser();
  const open = useSupportTicketStore((s) => s.open);

  if (user?.isImpersonating) return null;

  return (
    <Tooltip title="Open Support Ticket" placement="topLeft">
      <HelpButton
        aria-label="Open support ticket"
        data-testid="support-ticket-button"
        onClick={open}>
        <Icon path={mdiHelp} size="32px" />
      </HelpButton>
    </Tooltip>
  );
}

export default SupportButton;

const HelpButton = styled.button`
  position: fixed;
  bottom: 14px;
  left: 16px;
  z-index: 1000;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: var(--color-primary);
  color: var(--color-text-on-primary, #fff);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);

  svg {
    color: var(--color-text-on-primary, #fff);
  }
`;
